// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1_o4Q","footer":"Form_footer__3gPP4"};